import { Pipe, PipeTransform } from '@angular/core';

import { Amount } from '@fcom/dapi';

import { multiplyAmount } from '../utils/price-utils';

/**
 * Multiplies amounts using multiplyAmount utility
 * @see multiplyAmount
 */
@Pipe({
  name: 'finMultiplyAmount',
  standalone: false,
})
export class MultiplyAmountPipe implements PipeTransform {
  transform(amount: Amount, multiplyBy: number): Amount {
    return multiplyAmount(amount, multiplyBy);
  }
}
